import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Bar, BarChart,
} from "recharts";

export default function Performance() {
  const [data, setData] = useState({ totals: {}, daily: [] });

  useEffect(() => {
    api.get("/performance/summary").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const t = data.totals;
  const tooltipStyle = { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 12, color: "#1f2937" };

  return (
    <div className="p-8 space-y-6 max-w-[1500px]">
      <div>
        <h1 className="text-3xl font-display text-gray-900">Performance</h1>
        <p className="text-sm text-gray-500 mt-1">Synthetic Meta data — real metrics flow in after channel connection.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          ["Impressions", (t.impressions || 0).toLocaleString()],
          ["Clicks", (t.clicks || 0).toLocaleString()],
          ["Spend", `$${(t.spend || 0).toLocaleString()}`],
          ["Conversions", t.conversions || 0],
        ].map(([k, v]) => (
          <div key={k} className="bg-white border border-gray-200 rounded-xl p-5">
            <p className="text-xs font-medium text-gray-500">{k}</p>
            <p className="font-display text-2xl mt-2 tabular-nums text-gray-900">{v}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <p className="text-sm font-semibold text-gray-900 mb-4">Impressions × Clicks</p>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={data.daily}>
              <CartesianGrid stroke="#f3f4f6" />
              <XAxis dataKey="date" stroke="#9ca3af" tick={{ fontSize: 10 }} />
              <YAxis stroke="#9ca3af" tick={{ fontSize: 10 }} />
              <Tooltip contentStyle={tooltipStyle} />
              <Line type="monotone" dataKey="impressions" stroke="#ee9037" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="clicks" stroke="#656462" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <p className="text-sm font-semibold text-gray-900 mb-4">Daily spend</p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data.daily}>
              <CartesianGrid stroke="#f3f4f6" />
              <XAxis dataKey="date" stroke="#9ca3af" tick={{ fontSize: 10 }} />
              <YAxis stroke="#9ca3af" tick={{ fontSize: 10 }} />
              <Tooltip contentStyle={tooltipStyle} />
              <Bar dataKey="spend" fill="#ee9037" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
